module.exports = __webpack_public_path__ + "01_bob_black.f7c0a110.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_bob_black.png
// module id = ymM5
// module chunks = 0